import React from "react";
import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { resolveErrorMessage } from "../../utils/resolveErrorMessage";
import { DeleteInstalledBaseNodeSubscription } from "../../graphql/mutations/deleteInstalledBaseNodeSubscription";
import ConfirmDeleteModal from "../ConfirmDeleteModal";

interface Props {
    open: boolean;
    subscriptionId: string;
    nodeTitle?: string;
    onClose: () => void;
}

const DeleteSubscriptionModal = ({ open, subscriptionId, nodeTitle, onClose }: Props) => {
    const { t } = useTranslation();

    const [deleteSubscription, { loading }] = useMutation(DeleteInstalledBaseNodeSubscription, {
        refetchQueries: ["InstalledBaseNodeSubscriptions"],
    });

    const handleConfirm = () => {
        deleteSubscription({ variables: { id: subscriptionId } })
            .then((res) => {
                if (res.data?.deleteInstalledBaseNodeSubscription?.success === false) {
                    toast.error(
                        res.data.deleteInstalledBaseNodeSubscription.message || t("Failed to delete subscription.")
                    );
                    return;
                }
                toast.success(
                    nodeTitle ? t('Removed subscription for "{{title}}".', { title: nodeTitle }) : t("Subscription removed.")
                );
                onClose();
            })
            .catch((err) => toast.error(resolveErrorMessage(err, t)));
    };

    return (
        <ConfirmDeleteModal
            open={open}
            loading={loading}
            onConfirm={handleConfirm}
            onClose={onClose}
            title={t("Delete subscription")}
            message={
                nodeTitle
                    ? t(
                          "Are you sure you want to permanently delete the subscription for {{name}}? This action cannot be undone.",
                          { name: nodeTitle }
                      )
                    : t("Are you sure you want to permanently delete this subscription? This action cannot be undone.")
            }
        />
    );
};

export default DeleteSubscriptionModal;
